<template>
  <ion-card>
    <ion-card-content>
      <ion-item>
        <ion-label position="floating">
          Name
        </ion-label>
        <ion-input-vue
          v-model="name"
          required
        />
      </ion-item>

      <ion-item>
        <ion-label position="floating">
          Room
        </ion-label>
        <ion-select-vue
          v-model="deviceGroupUuid"
          interface="popover"
        >
          <ion-select-option
            v-for="deviceGroup in deviceGroups"
            :key="deviceGroup.uuid"
            :value="deviceGroup.uuid"
          >
            {{ deviceGroup.name }}
          </ion-select-option>
        </ion-select-vue>
      </ion-item>
    </ion-card-content>

    <ion-card-footer>
      <ion-button 
        expand="full"
        :disabled="busy"
        @click="save"
      >
        <ion-spinner v-if="busy" />
        <template v-else>
          Add
        </template>
      </ion-button>
    </ion-card-footer>
  </ion-card>
</template>

<script>
import { IonInputVue, IonSelectVue, modalController } from '@modus/ionic-vue'
import { mapGetters } from 'vuex'

import store from '../../state'
import router from '../../router'

export default {
  components: {
    IonInputVue,
    IonSelectVue
  },
  data() {
    return {
      busy: false,
      name: '',
      deviceGroupUuid: null
    }
  },
  computed: {
    ...mapGetters([
      'getBridgeBySerial',
      'getDeviceBySerial'
    ]),
    bridge() {
      return this.getBridgeBySerial(this.serialNumber)
    },
    deviceGroups() {
      return this.bridge.deviceGroups
    },
  },
  created() {
    // set manually in modal
    this.serialNumber = router.currentRoute.params.serialNumber
    this.$store = store
  },
  methods: {
    save() {
      this.busy = true
      this.$store
          .dispatch('storeVirtualConverter', {
            serialNumber: this.serialNumber,
            name: this.name,
            deviceGroupUuid: this.deviceGroupUuid
          })
          .then(() => modalController.dismiss())
          .finally(() => this.busy = false)
    }
  }
}
</script>

<style scoped>
ion-card {
  margin:0;
}
</style>

<style>
.external-client-modal .modal-wrapper {
  background:none;
}
</style>